"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import { lazy, useState, useEffect, Suspense } from 'react';
import { useIsSSR } from 'react-aria';

const nonResolvingPromise = new Promise(
  () => {
  }
);
const SuspenseTrigger = lazy(() => nonResolvingPromise);
const Activity = (props) => {
  const { children, isActive: isActiveFromProps = true, inactiveDelay } = props;
  const [isActiveState, setIsActiveState] = useState(isActiveFromProps);
  const isSsr = useIsSSR();
  useEffect(() => {
    if (!inactiveDelay) {
      return;
    }
    if (isActiveFromProps) {
      setIsActiveState(true);
    } else {
      const timeout = setTimeout(() => {
        setIsActiveState(false);
      }, inactiveDelay);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [isActiveFromProps, inactiveDelay]);
  const isActive = inactiveDelay ? isActiveState : isActiveFromProps;
  if (isSsr) {
    return isActive ? children : null;
  }
  return /* @__PURE__ */ jsxs(Suspense, { fallback: null, children: [
    !isActive && /* @__PURE__ */ jsx(SuspenseTrigger, {}),
    children
  ] });
};

export { Activity, Activity as default };
//# sourceMappingURL=Activity.mjs.map
